export default __webpack_public_path__ + "static/media/waiterServer.28b87320.svg";